export const CONFIG_OPERATIVITY_AQUA = {
  present: {
    variables: {
      waves: {
        alias: "Wave Significant Height",
        name: "hm0",
        thresholds: {
          max: 3,
          min: 0
        }
      }
      // currents: {
      //   alias: "Currents velocity",
      //   name: "CurrSpeed"
      // }
    }
  },
  shortTerm: {
    variables: [
      {
        id: 32,
        name: "Wave Significant Height",
        productId: 21, //"WEKEO_GLOBAL_ANALYSIS_FORECAST_WAV_001_027",
        thresholds: {
          max: 3,
          min: 0
        }
      },
      {
        id: 0,
        name: "Currents (sea water velocity)",
        alias: "Currents",
        productId: 22, //"WEKEO_GLOBAL_ANALYSIS_FORECAST_PHY_001_024",
        units: "m/s",
        thresholds: {
          max: 0.5,
          min: 0
        },
        components: [
          {
            id: 18,
            name: "Sea water x velocity"
          },
          {
            id: 19,
            name: "Sea water y velocity"
          }
        ]
      }
    ]
  }
};
export const CONFIG_OPERATIVITY_ENERGY = {
  present: {
    variables: {
      waves: {
        alias: "Wave Significant Height",
        name: "hm0",
        thresholds: {
          max: 3,
          min: 0
        }
      },
      wind: {
        alias: "Wind Speed",
        name: "WindSP",
        thresholds: {
          max: 15,
          min: 0
        }
      },
      tp: {
        alias: "Waves Period",
        name: "tp",
        thresholds: {
          max: 12,
          min: 0
        }
      }
    }
  },
  shortTerm: {
    variables: [
      {
        id: 32,
        name: "Wave Significant Height",
        productId: 21, //"WEKEO_GLOBAL_ANALYSIS_FORECAST_WAV_001_027",
        thresholds: {
          max: 3,
          min: 0
        }
      },
      {
        id: 0,
        name: "Wind velocity",
        units: "m/s",
        alias: "Wind",
        productId: 18, //"NOAA_GFS_025",
        thresholds: {
          max: 15,
          min: 0
        },
        components: [
          {
            id: 109,
            name: "grid eastward wind"
          },
          {
            id: 110,
            name: "grid northward wind"
          }
        ]
      }
    ]
  }
};
